// React
import { FC } from 'react';
// Types
import { EventsWorldMapMarkerIconProps } from '@utmb/types/map';
import { Font } from '@utmb/design-system/text/font';
import styles from './map.module.scss';
import { IconsEnum } from '@utmb/types/icons';
import EventWorldMapIcon from './EventWorldMapIcon';
import LogoFinals from '@utmb/design-system/icons/svgs/LogoFinals';
import UtmbRunner from '@utmb/design-system/icons/svgs/UtmbRunner';
import LogoMajor from '@utmb/design-system/icons/svgs/LogoMajor';
import { Icon } from '@utmb/design-system/icons/Icon';

export const EventsWorldMapMarkerIcon: FC<EventsWorldMapMarkerIconProps> = ({ color, eventView, isOpen }) => {
    const { isFinal, isMajor, title, placeName, country } = eventView;

    return ( !isOpen ?
        /* Cas normal */
        (<div className={[styles.worldmap_marker, isMajor || isFinal ? styles.bigger : null].filter(Boolean).join(' ')}>
            <EventWorldMapIcon color={color} />
            {isFinal && <UtmbRunner color="#ffffff" clss={styles.icon_final} />}
            {isMajor && <LogoMajor color="#ffffff" clss={styles.icon_major} />}
            <div>
                {isFinal && <Font.FuturaBold mobile="12" className="lh-15" as="div">FINALS</Font.FuturaBold>}
                {isMajor && <Font.FuturaBold mobile="12" className="lh-15" as="div">MAJOR</Font.FuturaBold>}
                <Font.FuturaBook mobile="13" className="lh-15" as="div">{title}</Font.FuturaBook>
            </div>
        </div>)
        : (
        /* Cas après clic */
        <div className={styles.worldmap_marker_open} style={{backgroundColor: color}}>
            <div>
                {isFinal ? <LogoFinals color="#00dbff" clss={styles.icon_final} /> : isMajor ? <LogoMajor color="#ffffff" clss={styles.icon_major} /> : <></>}
            </div>
            <div>
                <Font.FuturaBold mobile="12" className={styles.title} as="div">{title}</Font.FuturaBold>
                <div>
                    <Icon variant={IconsEnum.PIN} color="#ffffff"/>
                    <Font.FuturaBook mobile="13" className="lh-15" as="div">{placeName}, {country}</Font.FuturaBook>
                </div>
            </div>
        </div>)
    );
};
